<ng-content></ng-content>
<mat-spinner *ngIf="loading" [diameter]="48"></mat-spinner>
<mat-label *ngIf="!hasMore && !loading">没有更多数据</mat-label>
